import { Modules } from "@lib/titan2/dist/game/Constants";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Point } from "pixi.js";
import { FeatureReelSymbolProperties } from "./FeatureReelSymbolProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { GameFontStyle } from "../../../style/GameFontStyle";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
export class FeatureReelProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.reelSymbolProperties = new FeatureReelSymbolProperties();
        this.value = new TextFieldProperties(GameFontStyle.GOLD_FISH_SYMBOL_VALUE, new Point(75, 134), null, ControlConstants.CENTER, ControlConstants.TOP, new Point(180, 150));
        this.multipliedValue = new TextFieldProperties(GameFontStyle.GOLD_FISH_SYMBOL_MULTIPLIED_VALUE, new Point(75, 134), null, ControlConstants.CENTER, ControlConstants.TOP, new Point(180, 150));
        this.lock = new SpineProperties("GoldFishLock", Modules.GAME, new Point(120, 28));
    }
    ;
    equals(other) {
        return true;
    }
}
//# sourceMappingURL=FeatureReelProperties.js.map